<template>
  <a class="c-header-link" :href="linkItem.url">
    <i :class="['c-header-link__icon', `icon-${iconName}`]"></i>
    <h3
      class="c-header-link__title"
      v-html="linkItem.getMarkedTitle(markWord)"
    ></h3>
    <i
      v-if="deletable"
      class="icon-x c-header-link__delete"
      @click.stop.prevent="$emit('delete-clicked')"
    ></i>
  </a>
</template>

<script>
import { LinkItem } from '~/js/models/linkItem'

export default {
  name: 'ComponentHeaderLink',
  props: {
    deletable: { type: Boolean, default: false },
    iconName: { type: String, required: true, default: 'heart-filled' },
    linkItem: { type: LinkItem, default: null },
    markWord: { type: String, default: '' },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/reset-new';
.c-header-link {
  align-items: center;
  display: flex;
  transition: 0.3s;

  &:hover {
    opacity: 0.6;
  }

  &__icon {
    font-size: 16px;
  }

  &__title {
    display: -webkit-box;
    font-weight: 600;
    font-size: 12px;
    flex-grow: 1;
    height: 1em * 1.5;
    margin-left: 8px;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;

    :deep(mark) {
      font-weight: 800;
    }
  }

  &__delete {
    margin-left: 8px;
    font-size: 10px;
  }
}
</style>
